import ProductGrid from "./ProductGrid";

export default ProductGrid;



// WEBPACK FOOTER //
// ./src/components/Products/index.js